import { TransformedHtml } from './TransformedHtml';

export default TransformedHtml;
